import {
  AnnotationIcon,
  MailIcon,
  UserAddIcon,
} from "@heroicons/react/outline";
import React, { Component } from "react";
import IlluFive from "../../images/illu_five.png";

const kawanKitaSteps = [
  {
    id: 1,
    name: "Registration",
    description:
      "Fill in your contact information and account credentials. Examples of information that we do collect are such as occupation details and physical address. This information is collected by MySukarela to match you with volunteering tasks that are personalised to you.",
    icon: UserAddIcon,
  },
  {
    id: 2,
    name: "Browse For Projects",
    description:
      "Search for volunteering projects that are nearby to you. You can view all the available slots for volunteering. Book an available slot to confirm your participation in volunteering.",
    icon: MailIcon,
  },
  {
    id: 3,
    name: "Volunteer and Deliver",
    description:
      "Additional information will be sent to your email address if there are any rules/procedures by the organisations (NGO) that you are volunteering for. Feel free to reach out our customer support if you have any questions.",
    icon: AnnotationIcon,
  },
];

export default class Steps extends Component {
  render() {
    return (
      <div className="pb-16 overflow-hidden w-full lg:pb-24">
        <div className="relative max-w-md sm:max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
          <div className="relative mt-12 sm:mt-16 lg:mt-24">
            <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="lg:col-start-2">
                <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
                  Steps To Become A Volunteer
                </h3>
                <p className="mt-3 text-lg text-gray-500 font-body">
                  Join MySukarela family with these simple steps below :
                </p>

                <dl className="mt-10 space-y-10 font-body">
                  {kawanKitaSteps.map((item) => (
                    <div key={item.id} className="relative">
                      <dt>
                        <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-red-600 text-white">
                          <item.icon className="h-6 w-6" aria-hidden="true" />
                        </div>
                        <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                          {item.name}
                        </p>
                      </dt>
                      <dd className="mt-2 ml-16 text-base text-gray-500">
                        {item.description}
                      </dd>
                    </div>
                  ))}
                </dl>
              </div>

              <div className="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1">
                <svg
                  className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden"
                  width={784}
                  height={404}
                  fill="none"
                  viewBox="0 0 784 404"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="e80155a9-dfde-425a-b5ea-1f6fadd20131"
                      x={0}
                      y={0}
                      width={20}
                      height={20}
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x={0}
                        y={0}
                        width={4}
                        height={4}
                        className="text-gray-200"
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect
                    width={784}
                    height={404}
                    fill="url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)"
                  />
                </svg>
                <img
                  className="relative mx-auto rounded"
                  width={550}
                  src={IlluFive}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
